// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"175f3b36","453":"6dee12cc","455":"6c6b794b"}[chunkId] + ".chunk.js";
};